module.exports = __webpack_public_path__ + "img/Shaanxi-speed.1cf28db3.png";